import React from 'react';
import { useFormContext } from '../../../hoc/form';

export default function Submit({ submittingValue, ...props }) {
	const context = useFormContext();
	if(context?.submitting) {
		props.disabled = true;
		props.value = submittingValue || props.value;
	}
	return <input {...props} />;
}
